import type { MutableRefObject } from 'react';
import { useCallback, useEffect, useRef, useState } from 'react';

import { useTracking } from '@change-corgi/core/react/tracking';

import { useTrackView } from 'src/app/shared/hooks/tracking';

import { useBannerClosedStateStorage } from '../../../hooks/useBannerClosedStateStorage';

type Result = ModelHookResult<
	{
		visible: boolean;
		ref: MutableRefObject<HTMLElement | null>;
	},
	{
		onClickClose: () => void;
	}
>;

export function useLayout(): Result {
	const [visible, setVisible] = useState(true);
	const ref = useRef<HTMLElement | null>(null);
	const track = useTracking();
	useTrackView('petition_membership_popup_shown');
	const { setBannerClosed } = useBannerClosedStateStorage();

	const onClickClose = useCallback(() => {
		void track('petition_membership_popup_closed');
		setVisible(false);
		setBannerClosed('true');
	}, [track, setBannerClosed]);

	useEffect(() => {
		const handleClick = (event: MouseEvent) => {
			// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
			if (ref.current && !ref.current.contains(event.target as Node)) {
				onClickClose();
			}
		};

		document.addEventListener('click', handleClick);
		return () => document.removeEventListener('click', handleClick);
	}, [ref, onClickClose]);

	return {
		data: {
			visible,
			ref,
		},
		actions: {
			onClickClose,
		},
	};
}
